import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { UntypedFormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { LaunchDarklyService } from 'src/app/core/services/launchdarkly.service';
import { FEATURE_FLAGS } from 'src/app/shared/launchdarkly.constants';

@Component({
  selector: 'app-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss', '../form-fields.component.scss'],
})
export class CheckboxComponent implements OnInit, OnChanges, OnDestroy {
  @Input('form') form!: UntypedFormGroup;
  @Input('label') label!: string;
  @Input('infoText') infoText!: string;
  @Input('controlName') controlName!: string;
  // type = toggle if toggle button is required
  @Input('type') type: 'toggle' | 'check' = 'check';
  @Output('change') change = new EventEmitter<any>();
  // in case form is not passed use this flag to mark checkbox as checked
  @Input('checked') checked: boolean = false;
  @Input('disabled') disabled: boolean = false;
  @Input('customClass') customClass: string = '';
  @Input('isHeader') isHeader: boolean = false;
  @Input('IsFormFieldNameHidden') IsFormFieldNameHidden = false;
  @Input('IsFromForm') IsFromForm:boolean = false;
  @Input('IsInfoVisible') IsInfoVisible:boolean = true;
  @Input('DisplayOnScreen') DisplayOnScreen:boolean = false;
  @Input('AllowMinimize') AllowMinimize:boolean = false;
  @Input('showEditIcon') showEditIcon:boolean = false;
  @Input('showPlugIcon') showPlugIcon:boolean = false;
  @Output('editClicked') editClicked = new EventEmitter<any>();
  // Accessibility attributes
  @Input('ariaLabel') ariaLabel?: string;
  @Input('ariaDescribedBy') ariaDescribedByFromParent?: string;
  @Input() isRequired: boolean = false;
  @Input('requiredMessage') requiredMessage: string = 'This field is required';
  @Input('errorMessagePrefix') errorMessagePrefix: string = '';
  isAuthAccessibilityEnabled: boolean = false;
  isTextVisible:boolean = true
  validator = Validators.required;
  private ldSubscription?: Subscription;

  constructor(private readonly ldService: LaunchDarklyService) {}

  ngOnInit(): void {
    this.ldSubscription = this.ldService.getFlagValue(FEATURE_FLAGS.ENABLE_AUTH_ACCESSIBILITY, false)
      .subscribe((value) => { this.isAuthAccessibilityEnabled = !!value; });
  }

  ngOnDestroy(): void {
    this.ldSubscription?.unsubscribe();
  }

  ngOnChanges(changes: SimpleChanges): void {
    const disabled = changes?.disabled?.currentValue;
    if (disabled === false) {
      this.form?.controls?.[this.controlName]?.enable();
    } else if (disabled === true) {
      this.form?.controls?.[this.controlName]?.disable();
    }
  }

  /**
   * Random string of len 5
   * @returns
   */
  private getRandom = () =>
    Math.random()
      .toString(36)
      .replace(/[^a-z]+/g, '')
      .substr(0, 5);

  random = this.getRandom();

  toggleText(event:MouseEvent): void {
    event.stopPropagation();
    this.isTextVisible = !this.isTextVisible;
  }

  get control() {
    return this.form?.controls?.[this.controlName];
  }

  getErrorMessage(): string {
    if (this.control?.hasError('required')) return this.requiredMessage;
    return '';
  }

  getAriaDescribedby(): string | null {
    const errorId = this.control?.dirty && this.control?.errors ? `checkbox-${this.controlName}${this.random}-error` : null;
    if (this.ariaDescribedByFromParent && errorId) {
      return `${this.ariaDescribedByFromParent} ${errorId}`;
    }
    return this.ariaDescribedByFromParent || errorId || null;
  }
}
